import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { useDisabledDatePresets } from '@/App/tiles/shared/useDisabledDatePresets.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorLastFixing,
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const LastFixingDate = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();

  const { lastFixingDate, lastFixingTenor } = useAppSelector((state) =>
    selectForwardAccumulatorLastFixing(state, tileId),
  );

  const currencyPair = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'currencyPair'));
  const disabledDatePresets = useDisabledDatePresets(tileId, currencyPair);

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleDateChange = useCallback(
    (dateOrTenor: string) => {
      sgwtWebAnalytics?.trackEvent('ForwardAccumulator', 'Last Fixing Date changed', dateOrTenor);

      check({
        lastFixingDate: dateOrTenor,
      });
    },
    [check, sgwtWebAnalytics],
  );

  return (
    <FormField formattedMessageId="targetAccumulator.form.lastFixingDate">
      <TradeCaptureValidationWrapper validation={validation?.lastFixingDate}>
        <DatePickerWithTenorNext
          date={lastFixingDate}
          tenor={lastFixingTenor}
          data-e2e="last-fixing-date-input"
          onChange={handleDateChange}
          disablePresets={disabledDatePresets}
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default LastFixingDate;
